import React, { useState,useEffect } from 'react';
import { Button, ButtonGroup,Row,Col } from 'reactstrap';


const Pagination = ({postsPerPage,totalPosts,paginate}) => {
    const [cluster,setCluster] = useState(1)
    var pageNumbers = [];
    var pageNumbers2 = [];
    //console.log(postsPerPage,totalPosts)
    for (let i = 1;i<=Math.ceil(totalPosts /postsPerPage);i++){
        pageNumbers.push(i)
        pageNumbers2.push(i)
    }
    
    var totalRows = []
   
    while(pageNumbers2.length){
        totalRows.push(pageNumbers2.splice(0,9))
    }
    
    //console.log(totalRows,pageNumbers)
    return(
        <nav style={{marginLeft:'20px'}}>
            <ul className='pagination'>
                
                {totalRows[cluster-1]?.map(number => (
                    <li key={number} className='page-item' style={{backgroundColor:'rgb(20,20,20)'}}>
                        <a style={{backgroundColor:'rgb(30,30,30)',borderColor:'rgb(20,20,20)'}} onClick={() =>paginate(number)}href='#' className='page-link'>
                            {number}
                        </a>
                    </li>
                ))} 
            </ul>
            <Row>
                    <Col xs={4} md={4} lg={4}>
                        <ButtonGroup>
                            <Button className='text-warning' onClick={() =>cluster>1 ? setCluster(cluster-1) : setCluster(cluster)}>{cluster>1? cluster-1 : cluster}</Button>
                            <Button className='text-warning' onClick={() => setCluster(1)}>Start</Button>
                            <Button className='text-warning' onClick={() =>cluster<totalRows.length? setCluster(cluster+1) : setCluster(cluster)}>{cluster<pageNumbers[pageNumbers.length-1]? cluster+1 : cluster}</Button>
                        </ButtonGroup>
                    </Col>
                    
                </Row>
        </nav>
    )
}

export default Pagination;
